exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".info-icon{min-width:16px !important;display:-ms-flexbox !important;display:flex !important;width:16px;height:16px;-ms-flex-align:center;align-items:center;-ms-flex-pack:center;justify-content:center;background-color:#000;color:#fff;border-radius:10px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/postcss-loader/lib??ref--1-2!./node_modules/sass-loader/dist/cjs.js??ref--1-3!./src/common/icon/styles/iconStyles.scss
// module id = 5981
// module chunks = 0